import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { backUrl } from "../config";

const redPath = "dogovorApi";
const tagApi = "dogovors";

export const dogovorApi = createApi({
  reducerPath: redPath,
  baseQuery: fetchBaseQuery({
    baseUrl: backUrl,
    tagTypes: [tagApi],
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.accessToken;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getDogovors: build.query({
      query: (param) => `${tagApi}${param ? param : ""}`,
      providesTags: [tagApi],
    }),
    createDogovor: build.mutation({
      query: (newData) => ({
        url: `${tagApi}`,
        method: "POST",
        body: {
          data: {
            ...newData,
          },
        },
      }),
      invalidatesTags: [tagApi],
    }),
    updateDogovor: build.mutation({
      query: (newData) => ({
        url: `${tagApi}/${newData.id}`,
        method: "PUT",
        body: {
          data: {
            ...newData.updated,
          },
        },
      }),
      invalidatesTags: [tagApi],
    }),
  }),
});

export const {
  useGetDogovorsQuery,
  useCreateDogovorMutation,
  useUpdateDogovorMutation,
} = dogovorApi;
